module.exports = __webpack_public_path__ + "static/img/scenes_icon_businessTrip.b2bbb2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenes_icon_businessTrip.png
// module id = TCci
// module chunks = 1